import React, { Component } from 'react'
import styles from './MapInfo.css'
import PropTypes from 'prop-types'

/**
 * Displays the center of the map and zoom level
 */
class MapInfo extends Component {
  static propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    zoom: PropTypes.number,
  }

  static defaultProps = {
    lat: 0,
    lng: 0,
    zoom: 0,
  }

  render() {
    const { lat, lng, zoom } = this.props
    return (
      <div className={styles.MapInfo}>
        <div>{`Lat: ${lat}`}</div>
        <div>{`Lng: ${lng} `}</div>
        <div>{`Zoom: ${zoom}`}</div>
      </div>
    )
  }
}

export default MapInfo
